import React, { useEffect, useState } from 'react';
import css from './index.css';
import EditForm from './EditForm';
import AdminHOC from '../AdminPanelsPage/AdminHOC';
import AdminActionsNav from '../AdminPanelsPage/AdminActionsNav';
import { useRequest } from '../../hooks/useRequest';
import { Alert, IconSpinner } from '../../components';
import { getUserNotifications } from '../../util/api';
// import CountriesTab from '../LandingPage/common/CountriesTab';
import OfferBlock from '../LandingPage/sectionsForClubs/SectionOurPartners/OfferBlock';
import { FiltersBadge as SecondaryFiltersPopup } from '../AdminPanelsPage/FiltersBadge';

const Panel = ({
    showList,
    handleAdminAction,
    handleSubmit,
    goBack,
    showForm,
    initialValues,
    action,
}) => {
    const [entities, setEntities] = useState([]);
    const [targetUsersType, setTargetUsersType] = useState([]);
    const [country, setCountry] = useState([]);
    const { error, loading, request } = useRequest();

    const filterByUserType = ({ userType }) => {
        return (
            !userType ||
            userType.length === 0 ||
            targetUsersType.length === 0 ||
            targetUsersType.some(c => userType.includes(c))
        );
    };

    const filterByCountry = ({ countries }) => {
        return (
            !country ||
            country.length === 0 ||
            countries.length === 0 ||
            countries.some(c => country.includes(c))
        );
    };

    const requestEntities = async () => await request(getUserNotifications, setEntities);

    useEffect(() => {
        requestEntities();
    }, []);

    if (loading) {
        return <IconSpinner />;
    }

    if (error) {
        return <Alert showAsPlainText type="failure" description={error} closeAllowed={false} />;
    }

    return (
        <>
            <AdminActionsNav
                handleAdding={() => handleAdminAction('add')}
                rootClassName={css.mainNavPanel}
            >
                <SecondaryFiltersPopup
                    optionsSelected={country.length + targetUsersType.length}
                    initialValues={{
                        country,
                        userType: targetUsersType,
                    }}
                    handleOptionUpdate={values => {
                        const { country, userType } = values || {};
                        setCountry(country || []);
                        setTargetUsersType(userType || []);
                    }}
                />
            </AdminActionsNav>

            {/* <CountriesTab country={country} setCountry={setCountry} /> */}

            {showList && (
                <div className={css.offersHolder}>
                    {(entities || [])
                        .filter(filterByCountry)
                        .filter(filterByUserType)
                        .map((offer, index) => (
                            <OfferBlock
                                key={index}
                                {...offer}
                                helperText={
                                    <span className={css.statistics}>
                                        clicks: {offer.clicks || 0} <br />
                                        impressions: {offer.impressions || 0}
                                    </span>
                                }
                                buttonLink={offer.link}
                                handleAdminAction={action => {
                                    handleAdminAction(action, offer);
                                }}
                            />
                        ))}
                </div>
            )}
            {showForm && (
                <p type="button" onClick={goBack} className={css.backButton}>
                    Zurück
                </p>
            )}
            {showForm && (
                <EditForm onSubmit={handleSubmit} initialValues={initialValues} action={action} />
            )}
        </>
    );
};

export default AdminHOC(Panel);
